import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Github } from "lucide-react";
import { env } from "@/config/env";
import { useAuthStoreV1 } from "@/stores/authStore_v1";

// ─── Not Connected View ───────────────────────────────────────────────────────

export function NotConnectedView() {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);
  const userId = useAuthStoreV1((s) => s.user?.id);

  useEffect(() => {
    if (searchParams.get("github_connected") !== "true") return;
    queryClient.invalidateQueries({ queryKey: ["gitConnection", orgId] });
    setSearchParams((prev) => { prev.delete("github_connected"); return prev; });
  }, []);

  const handleInstall = () => {
    const state = btoa(JSON.stringify({
      org_id: orgId,
      user_id: userId,
      redirect_url: window.location.href,
    }))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');

    const appSlug = env.NCODER_ENV === 'production' ? 'ncoder-ai-prod' : 'ncoder-ai-dev';
    window.location.href = `https://github.com/apps/${appSlug}/installations/new?state=${state}`;
  };

  return (
    <div className="flex h-full flex-col items-center justify-center py-20 text-center">
      <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl border border-border bg-card">
        <Github className="h-7 w-7 text-foreground" />
      </div>
      <h2 className="mb-2 text-lg font-semibold">Connect GitHub</h2>
      <p className="mb-8 max-w-sm text-sm text-muted-foreground leading-relaxed">
        Install the ncoder GitHub App on your organization to browse repos, inspect pull requests, and run pipeline checks.
      </p>
      <button type="button" onClick={handleInstall} className="studio-button studio-button-primary gap-2 px-5 py-2.5">
        <Github className="h-4 w-4" />
        Install GitHub App
      </button>
    </div>
  );
}
